import React from "react";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import moment from "moment";
import ExtendTime from "../GeneralFunctions/ExtendTime";

function Information() {
  const { informationContent, setShowInformationStrip, role, isMobile, isAndroidTablet } = useLiveStreamAppContext();
  const { type, message, classEndTimeUTC, setDurationUpdated } = informationContent;
  const { extendTimeFunction } = ExtendTime();

  function handleExtendTimeButton() {
    setShowInformationStrip(false);
    let meetingEndDate = moment(classEndTimeUTC)
      .add(10, "minutes")
      .local()
      .format("YYYY-MM-DDTHH:mm:ss");
    extendTimeFunction(meetingEndDate, 10);
    setDurationUpdated((prev) => prev + 10);
  }

  // Map of icon classes for each type
  const iconMap = {
    warn: "fa-triangle-exclamation",
    alert: "fa-circle-exclamation",
    success: "fa-check",
  };

  // Check if message is one of the extendable ones
  const isExtendableMessage =
    message === "5 minutes left in your scheduled meeting." ||
    message === "1 minute left in your scheduled meeting.";

  // Dynamically assign classes based on `type`
  const messageBarClasses = `message-bar msg-show-top ${
    type === "warn"
      ? "banner-warning-master"
      : type === "alert"
        ? "banner-fail-master"
        : type === "success"
          ? "banner-success-master"
          : ""
    }`;

  return (
    <>
      <div className={messageBarClasses}>
        {type && (
          <div className="font-awesome-solid-pro icon-banner">
            <i className={`fa-solid ${iconMap[type]}`} />
          </div>
        )}
        <div className="text-block-28">{message}</div>
        {role === "Presenter" && isExtendableMessage && (
          <div className="extend-btn-box" onClick={handleExtendTimeButton}>
            <a href className="cbtn brd-btn mb-btn extend-btn">Extend 10 Minutes</a>
          </div>
        )}
        {/* Close Button */}
        {role === "Presenter" && !isMobile && !isAndroidTablet && isExtendableMessage && <div className="close-icon-top"><i
          className="icon font-awesome-normal-pro va-times mb-close"
          onClick={() => setShowInformationStrip(false)}
        /></div>}
      </div>
    </>
  );
}

export default Information;
